// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/documentUpload/components/DocumentUploadForm.scss
// module id = 1965
// module chunks = 0